import SwiperCytiPortal from './component'

export default SwiperCytiPortal